import {useLeadStore} from "../store/Lead.store";
import {ButtonComponent} from "../../form/button.component";
import * as React from "react";
import {useState} from "react";
import {observer} from "mobx-react-lite";
import './step-actions.component.scss';
import useBelfiusTheme from "../theme/ThemeHooks";

interface StepActionsProps
{
    showCreateAppointment?: boolean,
    hideNextStep?: boolean
    createAppointmentTitle?: string,
    nextStepTitle: string,
}

export const StepActions = observer( ( props: StepActionsProps ) => {
    const store = useLeadStore();
    let {themeClassName} = useBelfiusTheme();
    const [nextStepRequested, setNextStepRequested] = useState( false );

    return <div className='d-flex justify-content-between w-100 leadgeneration-step-actions'>
        {props.showCreateAppointment && <ButtonComponent disabled={!store.canCreateAppointment()}
                                                         text={props.createAppointmentTitle || ''}
                                                         type='primary'
                                                         additionalCssClasses={['w-100']}
                                                         theme={themeClassName}
                                                         onClick={() => {
                                                             if ( store.canCreateAppointment() ) {
                                                                 store.createAppointment();
                                                             }
                                                         }}/>}
        {!props.hideNextStep && <ButtonComponent disabled={!store.currentStepValid() || nextStepRequested}
                         text={props.nextStepTitle}
                         onClick={() => {
                             if ( store.currentStepValid() ) {
                                 setNextStepRequested( true );
                                 store.goToNextStep();
                             }
                         }}
                         theme={themeClassName}
                         type={'primary'}
        />}
    </div>;
} );
